import { cn } from "@/lib/utils";
import { Play } from "lucide-react";

interface PlayButtonProps {
  handleOpenChange?: () => void;
}

export const PlayButton = ({ handleOpenChange }: PlayButtonProps) => {
  return (
    <button
      type="button"
      onClick={handleOpenChange}
      aria-label="Play video"
      className={cn(
        "relative top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2",
        "glass-border",
        "sm:px-[2.580rem] sm:py-[1.325rem] px-6 py-3 shrink-0 rounded-full",
        "backdrop-blur-xl bg-white/5",
        "transition-all duration-200 group-hover:bg-white/10 group-active:scale-90",
      )}
    >
      <Play className="sm:w-8 sm:h-8 w-6 h-6 text-foreground fill-foreground" />
    </button>
  );
};
